export const login = "/";
export const register = "/sign-up";
export const inviteRegister = (code = ":code") => `${register}/${code}`;
export const activate = "/activate";
export const retrievePassword = "/retrieve";
export const resetPassword = "/reset";
export const createBoard = "/board/create";
export const chooseBoard = "/board/create";
export const sharedHelp = "/help";
export const terms = "/terms";
export const policy = "/policy";

export const ssoActivation = "/sso-activation/:ssoLink"

export const home = "/home";
export const projectEdit = (id = ":projectUuid") => `${home}/${id}`;
export const archived = `${home}/archived`;
export const editor = (id = ":estimateUuid", version) => `${home}/editor/project/${id}${version ? `/${version}` : ""}`;
export const editorRouter = `${home}/editor/project/:estimateUuid/:versionKey?`;
export const templateEditor = (id = ":estimateUuid", version) => `${home}/editor/template/${id}${version ? `/${version}` : ""}`;
export const templateEditorRouter = `${home}/editor/template/:estimateUuid/:versionKey?`;
export const pdfEditor = (id = ":estimateUuid") => `${home}/editor/pdf/${id}`;
export const budgetTracking = (id = ":estimateUuid") => `${home}/budgetTracking/${id}`;
// export const archivedDetails = (id=":id") => `${home}/archived/${id}`;
export const subscription = `${home}/subscription`;
export const pricing = `${subscription}/pricing`;
export const settings = `${home}/settings`;
// export const settingsPayment = `${settings}/payment`;
export const settingsPaymentHistory = `${settings}/payments`;
export const settingsPassword = `${settings}/password`;
export const settingsUpgrade = `${settings}/upgrade`;
export const settingsCompany = `${settings}/company`;
export const settingsProject = `${settings}/project`;
export const settingsCurrency = `${settings}/project/currency`;
export const settingsDomain = `${settings}/project/domain`;
export const settingsTimeEquiv = `${settings}/project/fte`;
export const settingsRates = `${settings}/project/rates`;
export const settingsProjectTypes = `${settings}/project/project_types`;
export const settingsLabels = `${settings}/project/labels`;
export const settingsIntegrations = `${settings}/integrations`;
export const settingsApiKeys = `${settings}/developer/api-keys`;
export const boards = `${home}/boards`;
export const boardAdd = `${home}/boards/add`;
export const contact = `${home}/contact`;
export const templates = `${home}/templates`;
export const library = `${home}/library`;
export const help = `${home}/help`;
export const team = `${home}/team`;
export const notifications = `${home}/notifications`;
export const jiraIntegration = `${home}/jira`;

export const sessions = (id = ":projectUuid") => `${home}/sessions/${id}`;
export const sessionReplay = (id = ":projectUuid", sessionId = ":sessionId") =>
  `${sessions(id)}/${sessionId}`;
// export const sessionHeatmap = (id = ":projectUuid", sessionId = ":sessionId") =>
//   `${sessionReplay(id, sessionId)}/heatmap`;
// export const sessionPdfHeatmap = (id = ":projectUuid", sessionId = ":sessionId") =>
//   `${sessionReplay(id, sessionId)}/pdfheatmap`;

export const sharedProposalOld = (hash = ":projectHash", version) => `/proposal/${hash}/${version}`;
export const sharedProposalOldRouter = "/proposal/:projectHash/:versionKey?";
export const sharedProposal = (
  company = ":company",
  project = ":project",
  hash = ":projectHash",
  version,
) => `/proposal/${company}/${project}/${hash}/${version}`;
export const sharedProposalRouter = "/proposal/:company/:project/:projectHash/:versionKey?";
export const sharedPdfProposalOld = (hash = ":projectHash") => `/proposalpdf/${hash}`;
export const sharedPdfProposal = (
  company = ":company",
  project = ":project",
  hash = ":projectHash",
) => `/proposalpdf/${company}/${project}/${hash}`;

export const printPdf = (
  company = ":company",
  project = ":project",
  hash = ":projectHash",
  version,
) => `/print/${company}/${project}/${hash}/${version}`;
export const printPdfRouter = "/print/:company/:project/:projectHash/:versionKey?";

//mail routes:
export const loginWorkspace = "/:workspaceUuid";
export const loginWorkspaceProject = "/:workspaceUuid/:projectId";
export const loginWorkspaceOpenedProject = "/:workspaceUuid/:projectId/estimate";
export const jiraAuth = "/auth/jira";

export const fullWidthViews = [
  editor(),
  templateEditor(),
  // library,
  pdfEditor(),
];

export const staticPageView = [
  sessionReplay(),
  pdfEditor(),
  sharedPdfProposal(),
  sharedPdfProposalOld(),
  // sessionPdfHeatmap(),
];

export const scrollablePageView = [
  // editor(),
  // pdfEditor(),
  // archived,
  // sessionReplay(),
  // sharedProposal(),
  // sharedPdfProposal(),
  // sessionHeatmap(),
  // sessionPdfHeatmap(),
  home,
  // workspaces,
  notifications,
  team,
];
